import { Typography } from "@mui/material";
import React from "react";
import DetailCaption from "./DetailCaption";
import SectionHeader from "./SectionHeader";
import Row from "components/layout/Row";

interface ScheduleDetail {
  time: string;
  description: string;
}

function Schedule() {
  const regularScheduleTimes: Array<ScheduleDetail> = [
    { time: "6:00 - 7:15", description: "Breakfast" },
    { time: "7:45", description: "Morning Assembly" },
    { time: "8:05", description: "Devotional Message" },
    { time: "8:30", description: "Dismiss to Sharing Groups" },
    { time: "9:00", description: "1st Period Class" },
    { time: "9:45", description: "Break" },
    { time: "10:00", description: "2nd Period Class" },
    { time: "10:45", description: "Break" },
    { time: "11:00", description: "3rd Period Class/Preschool crafts" },
    { time: "12:00", description: "Lunch" },
    { time: "1:00", description: "Crafts, Sacred Harp Singing" },
    { time: "2:00", description: "4th Period Class (except Preschool)" },
    { time: "2:30", description: "General Assembly" },
    { time: "3:15", description: "Chores" },
    { time: "3:45", description: "Recreation" },
    { time: "5:00", description: "Supper" },
    { time: "6:45", description: "Flag Ceremony" },
    { time: "7:00", description: "Vesper Service in Dalton Hall" },
    { time: "7:15", description: "General Assembly" },
    { time: "8:30", description: "Break/Visitation" },
    { time: "9:30", description: "Visiting Hours are Over" },
    { time: "10:30", description: "Lights Out and Taps" },
  ];
  const fridayNightTimes: Array<ScheduleDetail> = [
    { time: "4:30", description: "Supper" },
    {
      time: "6:30",
      description:
        "Dressing Buildings locked for Evening Session at the Pavilion",
    },
    { time: "6:45", description: "Flag Ceremony" },
    { time: "7:00", description: "Program" },
    {
      time: "10:00",
      description:
        "Visiting Hours are Over For Those Who Will Not Be Staying Overnight",
    },
    {
      time: "12:00",
      description:
        "Taps <b>No One</b> is Permitted to Leave Their Sleeping Area Without Adult Counselor Permission until 6:00 AM Saturday",
    },
  ];
  return (
    <>
      <SectionHeader>Schedule</SectionHeader>
      <DetailCaption>Regular Schedule</DetailCaption>
      {regularScheduleTimes.map((detail) => {
        return (
          <Row marginBottom={5}>
            <Typography style={{ minWidth: "80px" }} variant="body2">
              {detail.time}
            </Typography>
            <Typography variant="body2">{detail.description}</Typography>
          </Row>
        );
      })}
      <DetailCaption>Friday Night Schedule</DetailCaption>
      {fridayNightTimes.map((detail) => {
        return (
          <Row marginBottom={5}>
            <Typography style={{ minWidth: "80px" }} variant="body2">
              {detail.time}
            </Typography>
            <Typography variant="body2">
              <div dangerouslySetInnerHTML={{ __html: detail.description }} />
            </Typography>
          </Row>
        );
      })}
    </>
  );
}

export default Schedule;
